import React from "react";
import HeroBGSrc from "../assets/img/cancer/Breast_Banner.jpg";
import HeroBGSrcTablet from "../assets/img/cancer/Breast_Banner.jpg";
import HeroBGSrcMobile from "../assets/img/cancer/Breast_Banner.jpg";
import {
  getPhoneClaims,
} from "../helpers/ContentStateHelper";
import { Paths } from "../constants/UrlConstants";
import { Link } from "react-router-dom";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const Check4CancerBreast = {

  HeroBGSrc: HeroBGSrc,
  HeroBGSrcTablet: HeroBGSrcTablet,
  HeroBGSrcMobile: HeroBGSrcMobile,
  Heading:
    "Have you noticed any changes to your breasts?",
  Description: (
    <React.Fragment>
      <p>
        Find out about the breast diagnostic service we offer with Check4Cancer
      </p>

    </React.Fragment>
  ),
  c4cServiceAccess: "Who can access this service?",
  ServiceDescription: {
    Any: (state) => (
      <React.Fragment>
          If you have cover for outpatient specialist consultations and diagnostic tests, you can use this service. You can find this in your
        {" "} <Link style={{ fontSize: "16px" }}
           className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
           >
             membership documents  
           </Link>. If it’s appropriate, we’ll offer you an appointment with our diagnostic service provider Check4Cancer and explain how this may impact your outpatient limits and excess if you have one on your plan.
       <p></p>
            <p></p>    If you’re on a company scheme, you can check to see if your employer has selected the diagnostic cancer service with Check4Cancer by referring to your 
         {" "} <Link style={{ fontSize: "16px" }}
             className={"hol-link " + layoutStyle.anchorDecorationUnderline}
             to={Paths.Cover}
           >
             handbook
           </Link>. If your company hasn’t chosen this option, you will need to see your GP to get a referral before you can use this service. Once you have a referral, call us on {<strong>{getPhoneClaims(state)}</strong>} we’ll be happy to help.
     
      </React.Fragment>
    )
  },
  ServiceDescriptionIndSME: (
    <p>
      If you have cover for outpatient specialist consultations and diagnostic tests, you can use this service. You can find this in your{" "}
          <Link style={{ fontSize: "16px" }}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            membership documents  
          </Link>. If it’s appropriate, we’ll offer you an appointment with our diagnostic service provider Check4Cancer and explain how this may impact your outpatient limits, NCD and or excess if you have one on your plan.
    </p>
  ),
  c4cProcessHeader: "How does it work?",
  discussWithYourGPDetail: {
    Any: (state) => (
      <React.Fragment>
        <h3>Call us</h3>
        <p>
          If you’re worried about any changes to your breasts, <strong>you don’t need a GP referral</strong>. Call us on {<strong>{getPhoneClaims(state)}</strong>} and we’ll ask you a few questions to understand what’s causing you concern. If it’s appropriate, we’ll offer you an appointment with our diagnostic service provider Check4Cancer.
        </p>
        <p>We can normally offer you an appointment within <strong>5 working days</strong> of your call. And we’ll give you a choice of the location and date of your appointment, so you can attend when's easiest for you.</p>
      </React.Fragment>
    )
  },
  callUsDetail: (
    <React.Fragment>
      <h3>Check4Cancer</h3>
      <p>
        The Check4Cancer clinical team will then guide you through the next steps. You’ll receive a ‘one stop’ assessment with a nurse who’ll perform a clinical examination. If necessary they can then arrange for any further diagnostic tests with a specialist such as a mammogram and/or an ultrasound scan or biopsies.
      </p> <p>
        The tests will then be sent off for analysis and reviewed by the Check4Cancer specialists.
      </p>
    </React.Fragment>
  ),
  check4CancerDetail: (
    <React.Fragment>
      <h3>Results</h3>
      <p>
        Test results will typically be back within <strong>5 working days</strong>. If further treatment is required, a nurse will give you a call to explain the results and we’ll arrange any onward appointments for you.
      </p>
      <p><strong> Check4Cancer Opening hours: Monday – Friday 8am to 6pm </strong></p>
      <p></p>
    </React.Fragment>
  ),
};

export default Check4CancerBreast;
